<template>
	<div :class="filterClass" class="filter table-filter--search">
		<form @submit.prevent="apply()">
			<input v-model="filterValue" placeholder="Search" type="text">
		</form>
		<button v-if="filterValue" class="filter__clear" @click.prevent="clear()"><span>Clear filter</span>
		</button>
	</div>
</template>
<script>
export default {
	data() {
		return {
			filterValue: "",
		};
	},

	computed: {
		filterClass() {
			return {
				"filter--has-filter": !!this.filterValue,
			};
		},
	},

	props: {
		filter: {
			required: true,
			type: Function,
		},
		filterData: {
			required: true,
			type: Object,
		},
	},

	methods: {
		apply() {
			this.filter("search", this.filterValue);
		},
		clear() {
			this.filterValue = "";
			this.$parent.clearFilter("search");
			// this.filter("search", this.filterValue);
		},
	},

	created() {
		this.filterValue = this.filterData.value;
	},
};
</script>
